import ApiBase from 'Services/Api/ApiBase';

class MedicationDetails extends ApiBase {
    route = '/service-users/medication-details';
};

export default new MedicationDetails();